import React from 'react';

import { EntityModules } from 'core/constants';

import type { EntitiesStores } from '../types';

type FieldRenderer = (value: unknown) => React.ReactNode;

type FieldRules = {
  isVisible?: (fieldKey: string, values: Record<string, unknown>) => boolean;
  isRequired?: (fieldKey: string) => boolean;
};

export type UserSearchFilter = { licenses?: string; role?: string };

export type ExtraRowsProps = { store: EntitiesStores; fieldOrder: string[] };

type EntityFieldConfig = {
  renderers?: Record<string, FieldRenderer>;
  rules?: FieldRules;
  userFilters?: Record<string, UserSearchFilter>;
  ExtraRows?: React.FunctionComponent<ExtraRowsProps>;
};

const registry: Partial<Record<EntityModules, EntityFieldConfig>> = {};

export const registerEntityFieldConfig = (module: EntityModules, config: EntityFieldConfig): void => {
  registry[module] = config;
};

export const getFieldRenderer = (module: EntityModules, fieldKey: string): FieldRenderer | undefined =>
  registry[module]?.renderers?.[fieldKey];

export const isFieldVisible = (module: EntityModules, fieldKey: string, values: Record<string, unknown>): boolean =>
  registry[module]?.rules?.isVisible?.(fieldKey, values) ?? true;

export const getExtraRows = (module: EntityModules): React.FunctionComponent<ExtraRowsProps> | undefined =>
  registry[module]?.ExtraRows;

export const isFieldRequired = (module: EntityModules, fieldKey: string): boolean | undefined =>
  registry[module]?.rules?.isRequired?.(fieldKey);

export const getUserFilter = (module: EntityModules, fieldKey: string): UserSearchFilter | undefined =>
  registry[module]?.userFilters?.[fieldKey];
